import { useParams } from 'react-router';
import { useClientFetch } from '../../../context/ClientStatusContext';
import { ClientStatus } from '../../../model/ClientStatus';
import ClassType, { classTypeToGenerated } from '../../../model/pripomienka/ClassType';
import FilterData from '../../../model/filter/FilterData';
import { getFilterData } from '../../../client/filterDataClient';
import { useSecurityContext } from '../../../context/SecurityContext';

interface ReturnType {
  filterData: FilterData;
  filterDataStatus: ClientStatus;
  reloadFilterData?() : void;
}

export default (classType:ClassType): ReturnType => {
  // @ts-ignore
  const { type, year, index } = useParams<{ type: string, year: number, index: number }>();
  const { accessToken, organizationId } = useSecurityContext();

  const {
    data: filterData,
    status: filterDataStatus,
    refetch: reloadFilterData,
  } = useClientFetch(
    getFilterData,
    [classTypeToGenerated(classType), type, year, index],
    [accessToken, organizationId],
  );
  return {
    filterData, filterDataStatus, reloadFilterData,
  };
};
